export default "__VITE_PUBLIC_ASSET__22239182__"